module.exports = __webpack_public_path__ + "./img/Spear_v06_Gradient.6f4c97696ee709f03776bf1a584c17b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SpearGauge/images/Spear_v06_Gradient.png
// module id = ./src/components/SpearGauge/images/Spear_v06_Gradient.png
// module chunks = 0